module.exports = __webpack_public_path__ + "static/img/img_profile_dan.3e7e047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_profile_dan.jpg
// module id = 555
// module chunks = 1